import React from 'react';
import Row from 'react-bootstrap/Row';
import classNames from 'classnames';
import LIKE from './Fields/LIKE';
import DROPDOWN from './Fields/DROPDOWN';
import ASYNC from './Fields/ASYNC';
import MULTIPLE from './Fields/MULTIPLE';
import BOOLEAN from './Fields/BOOLEAN';
import GREATERTHAN from './Fields/GREATERTHAN';
import LESSTHAN from './Fields/LESSTHAN';
import DATE from './Fields/DATE';
import CHECKBOX from './Fields/CHECKBOX';
import RESET from './Fields/RESET';
import FilterTemplate from './FilterTemplate';

const Filter = ({
  className,
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Row, {
    className: classNames("grid-filter", null, className)
  }, children);
};

Filter.LIKE = LIKE;
Filter.DROPDOWN = DROPDOWN;
Filter.MULTIPLE = MULTIPLE;
Filter.ASYNC = ASYNC;
Filter.BOOLEAN = BOOLEAN;
Filter.GREATERTHAN = GREATERTHAN;
Filter.LESSTHAN = LESSTHAN;
Filter.DATE = DATE;
Filter.CHECKBOX = CHECKBOX;
Filter.RESET = RESET;
Filter.COLUMN = FilterTemplate;
export default Filter;